import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromStorages from '../reducers/storages.reducer';

export const selectStoragesState = createFeatureSelector<fromStorages.State>(
  fromStorages.storagesFeatureKey
);

export const selectStorageState = createSelector(
  selectStoragesState,
  (state: fromStorages.State) => state.storage
);

export const selectStoragesPathState = createSelector(
  selectStoragesState,
  (state: fromStorages.State) => state.storagesPath
);

export const selectStoragesFilterTypeState = createSelector(
  selectStoragesState,
  (state: fromStorages.State) => state.filterType
);

export const selectStoragesIsLoadingState = createSelector(
  selectStoragesState,
  (state: fromStorages.State) => state.isLoading
);

export const selectStoragesIsMaster = createSelector(
  selectStoragesState,
  (state: fromStorages.State) => state.isMasterChecked
);


export const selectStorageListState = createSelector(
  selectStoragesState,
  (state: fromStorages.State) => state.storages
);

export const selectStoragesFilterIDState = createSelector(
  selectStoragesState,
  (state: fromStorages.State) => state.filterID
);

export const selectStoragesQueryState = createSelector(
  selectStoragesState,
  (state: fromStorages.State) => state.query
);

export const selectStoragesSelectedState = createSelector(
  selectStoragesState,
  (state: fromStorages.State) => state.selected
);

export const selectStoragesSortState = createSelector(
  selectStoragesState,
  (state: fromStorages.State) => state.sortType
);

export const selectStoragesDirectionState = createSelector(
  selectStoragesState,
  (state: fromStorages.State) => state.direction
);

export const selectStoragePageState = createSelector(
  selectStoragesState,
  (state: fromStorages.State) => {
    state.direction
  }
);
